import React from 'react';
import { RecentUpload } from '../types';

interface ScanDetailCardProps {
  scan: RecentUpload;
}

const ScanDetailCard: React.FC<ScanDetailCardProps> = ({ scan }) => {
  return (
    <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg mt-4">
      <h4 className="text-md font-semibold text-gray-900 dark:text-white mb-2">Scan Details</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <img src={scan.filename} alt="Scan result" className="rounded-lg w-full" />
        </div>
        <div>
          <p><strong>Provider:</strong> {scan.api_provider}</p>
          <p><strong>Date:</strong> {new Date(scan.upload_time).toLocaleString()}</p>
          <p><strong>Status:</strong> {scan.status}</p>
          <div className="mt-2">
            <h5 className="font-semibold">Analysis Results:</h5>
            <pre className="bg-gray-100 dark:bg-gray-800 p-2 rounded text-xs whitespace-pre-wrap">
              {scan.ai_explanation || scan.description || scan.value ? (
                <pre className="bg-gray-100 dark:bg-gray-800 p-2 rounded text-xs whitespace-pre-wrap">
                  {scan.ai_explanation && `AI Explanation:\n${scan.ai_explanation}\n\n`}
                  {scan.description && `Description:\n${scan.description}\n\n`}
                  {scan.value && `Value:\n${scan.value}`}
                </pre>
              ) : (
                'No analysis data available.'
              )}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScanDetailCard;